import React from 'react'
import PropTypes from 'prop-types'
import validator from 'validator'
import { useNavigate } from 'react-router-dom'
import withAppStore from '../../../util/withAppStore'
import {
  FormattedMessage,
  injectIntl,
} from 'react-intl'
import NavigationBar from '../../partials/NavigationBar'
import Footer from '../../partials/Footer'
import {
  DivAccount,
  AuthCard,
  Title,
  MessageError,
  TitleError,
  Message,
  StyledInput,
  Label,
  Foot,
  ButtonWhite,
} from './styledComponents'

function Email (props) {
  const navigate = useNavigate()

  const confirmEmailInput = React.useRef()
  const emailInput = React.useRef()

  const errorFields = React.useRef([])

  const [state, setState] = React.useState({
    error: '',
  })

  React.useEffect(() => {
    const { email } = props.values || {}
    if (email !== null) {
      emailInput.current.value = email
      confirmEmailInput.current.value = email
    }
  }, [props.values])

  const next = React.useCallback(() => {
    validate((error) => {
      if (error) {
        setState(prevState => ({ ...prevState, error }), () => window.scrollTo(0, 0))
      } else {
        const email = emailInput.current.value
        const { onNext = () => {} } = props
        onNext({ email })
      }
    })
  }, [props])

  const validate = React.useCallback((callback) => {
    const {
      intl: {
        formatMessage,
      },
    } = props
    errorFields.current = []
    const { checkEmail = false } = props

    const email = emailInput.current.value
    const confirmEmail = confirmEmailInput.current.value

    if (!validator.isEmail(email) || email !== confirmEmail) {
      if (!validator.isEmail(email)) {
        errorFields.current = ['email']
        return callback(
          formatMessage({
            id: 'auth.email.invalid.validAddress',
            defaultMessage: 'Please enter a valid email address',
            description: 'Please enter a valid email address',
          })
        )
      }

      if (email !== confirmEmail) {
        errorFields.current = ['email', 'confirmEmail']
        return callback(
          formatMessage({
            id: 'auth.email.invalid.noMatch',
            defaultMessage: 'Emails don\'t match',
            description: 'Emails don\'t match',
          })
        )
      }
    } else {
      checkEmail(email)
        .then((result) => {
          if (result === true) {
            errorFields.current = ['email']
            return callback(
              formatMessage({
                id: 'auth.email.invalid.exists',
                defaultMessage: 'Email already exists in Altrac system',
                description: 'Email already exists in Altrac system',
              })
            )
          }

          // Empty means no errors, so IT IS valid input
          return callback(null)
        })
        .catch(() => {
          errorFields.current = ['email']
          return callback(
            formatMessage({
              id: 'auth.email.invalid.issue',
              defaultMessage: 'Issue checking email',
              description: 'Issue checking email',
            })
          )
        })
    }

    return null
  }, [props])

  const hasError = (f) => errorFields.current.includes(f)
  const { error } = state

  return (
    <DivAccount>
      <NavigationBar
        logOut={() => props.auth.logout(navigate)}
      />
      <AuthCard>

        <Title>
          <FormattedMessage
            id='auth.email.createAccount'
            defaultMessage='Create Account'
            description='Create Account label'
          />
        </Title>

        {
          error && (
            <MessageError>
              <TitleError>
                <FormattedMessage
                  id='auth.email.invalid.label'
                  defaultMessage='INVALID EMAIL'
                  description='INVALID EMAIL label'
                />
              </TitleError>
              <Message>
                {error}
              </Message>
            </MessageError>
          )
        }

        <Label>
          <FormattedMessage
            id='auth.email.provide1'
            defaultMessage='Please provide an email'
            description='Please provide an email label'
          />
          <StyledInput
            ref={emailInput}
            error={hasError('email')}
            name='email'
            type='email'
            autoComplete='email'
            required
            autoFocus
          />
        </Label>
        <Foot>
          <FormattedMessage
            id='auth.email.confirmationInfo'
            defaultMessage='A confirmation email will follow'
            description='A confirmation email will follow label'
          />
        </Foot>

        <Label>
          <FormattedMessage
            id='auth.email.provide2'
            defaultMessage='Confirm email'
            description='Confirm email label'
          />
          <StyledInput
            ref={confirmEmailInput}
            error={hasError('confirmEmail')}
            name='emailC'
            type='email'
            autoComplete='email'
            required
          />
        </Label>
        <Foot>
          <FormattedMessage
            id='auth.email.reenter'
            defaultMessage='Reenter your email'
            description='Reenter your email label'
          />
        </Foot>

        <ButtonWhite onClick={next}>
          <FormattedMessage
            id='resetPassword.next'
            defaultMessage='NEXT'
            description='NEXT label'
          />
        </ButtonWhite>
      </AuthCard>
      <Footer />
    </DivAccount>
  )
}

Email.propTypes = {
  checkEmail: PropTypes.func,
  values: PropTypes.object,
  onPrevious: PropTypes.func,
  onNext: PropTypes.func,
  auth: PropTypes.object,
  intl: PropTypes.object,
}


export default withAppStore(injectIntl(Email))
